<template>
	<div class="row">
		<h1 class="text-center"> Cертифицированный питомник леопардовой собаки катахулы</h1>
		<h1 class="text-center"> DragonPhoenix Catahoulas Kennel Lousiana catahoula Dog</h1>

		<p>
			Первый сертифицированный питомник леопардовой собаки катахулы (DragonPhoenix Catahoulas Kennel Lousiana catahoula Dog) был создан в 2014 году в Московской области.
		</p>
		<p>
			Развитие питомника началось с двух собак, привезенных из Словакии и Венгрии.
		</p>
	</div>
</template>

<script>

export default {
	name: 'About',
}

</script>

